import { createAction, props } from '@ngrx/store';

import { ContainerMeasurement } from 'app/features/manual-input-result-registration/models/container-measurement';
import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Container } from 'app/shared/features/container-selector/models';
import { Locations } from 'app/shared/features/location-selector/models';
import { FeedbackModel } from 'app/shared/models';

export const initializeContainerMeasurementStore = createAction(
    '[ContainerMeasurements] Initialize Container Measurement Store',
);

export const addContainerMeasurementRegistration = createAction(
    '[ContainerMeasurements] Add Container Measurement',
    props<{
        activityNumber: number;
        amountResult: number | undefined;
        containers: Container[];
        employeeNumberMultiUserMode: number | undefined;
        productBoxRegistrations: ProductBoxRegistration[];
        location: Locations | undefined;
    }>(),
);

export const addContainerMeasurementsToCache = createAction(
    '[ContainerMeasurements] Add Container Measurements To Cache',
    props<{
        containerMeasurements: ContainerMeasurement[];
    }>(),
);

export const sendCachedContainerMeasurements = createAction(
    '[ContainerMeasurements] Send Cached Container Measurements',
);

export const sendCachedContainerMeasurementsSuccess = createAction(
    '[ContainerMeasurements] Send Cached Container Measurements Success',
    props<{ sentContainerMeasurements: { [key: number]: ContainerMeasurement } }>(),
);

export const sendCachedContainerMeasurementsFailure = createAction(
    '[ContainerMeasurements] Send Cached Container Measurements Failure',
    props<{ errorMessage: string | undefined }>(),
);

export const showingToastAfterContainerMeasurement = createAction(
    '[ContainerMeasurements] Showing Toaster',
    props<{
        containerMeasurements: ContainerMeasurement[];
    }>(),
);

export const showingToastAfterContainerMeasurementSuccess = createAction(
    '[Registrations] Showing Performance Feedback Toaster',
    props<{
        feedback: FeedbackModel;
    }>(),
);

export const resetContainerMeasurementState = createAction(
    '[ContainerMeasurements] Reset Container Measurements state',
);
